import React, { useState, memo, useEffect } from "react";
import FormInput from "./FormInput";
import UserDataFields from "./UserDataFields/UserDataFields";
import axios from "axios";
import vdkShema from "../../images/cleverhead_schema_1.png";
import Loader from "../Loader";
import Table from "../Table/Table";
import FormSelector from "./FormSelector";

const MemoForm = memo(function Form() {
  const [resultFromApi, setResultFromApi] = useState(null);
  const [userRequest, setUserRequest] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorRequest, setErrorRequest] = useState(false);
  const [queryTable, setQueryTable] = useState(false);

  const [isPendingRequest, setIsPendingRequest] = useState(false);

  const changeUserData = (key, inputData) => {
    setErrorRequest(false);
    const queryObjectKey = key;
    setUserRequest((prev) => ({ ...prev, [queryObjectKey]: inputData }));
  };

  const submitHandler = async (e) => {
    setErrorRequest(false);
    e.preventDefault();
    if (resultFromApi) {
      setIsPendingRequest(true);
    }

    const token = "821717A5FDF14D57A347";
    setIsLoader(true);
    return await axios({
      method: "post",
      timeout: 10000 * 5,
      url: " http://api.vodokomfort.ru/ridan",
      headers: {
        "content-type": "application/json",
        "Cache-Control": "no-cache",
        Authorization: `Bearer ${token}`,
        Accept: "/",
      },

      data: userRequest,
    })
      .then((data) => {
        setResultFromApi(data.data);
        setShowError(false);
        setIsPendingRequest(false);
        if (data.data.errors) {
          setQueryTable(false);
          setErrorRequest(true);
        }
        if (data.data.solutions) {
          setQueryTable(true);
          setErrorRequest(false);
        }
      })
      .then(() => setIsLoader(false))
      .catch((err) => {
        setShowError(true);
        console.error(err);
        setIsLoader(false);
        setIsPendingRequest(false);
      });
  };

  useEffect(() => {
    if (userRequest) console.log("запрос", userRequest);
    if (resultFromApi) console.log("ответ сервера", resultFromApi);
  }, [resultFromApi, userRequest]);

  return (
    <>
      {showError && (
        <div className="interface_error-message">
          &#33; Проверьте подключение интернет соединения
        </div>
      )}
      <form>
        <input
          type="hidden"
          name="_token"
          value="KMderjNccFBJMpJKqqgpyZVt6qIKGVMk9zda82OE"
        />

        <table className="interface_table">
          <thead>
            <tr>
              <th scope="col" style={{ marginBottom: "20px" }}>
                Греющая сторона
              </th>
              <th scope="col" style={{ marginBottom: "20px" }}>
                Нагреваемая сторона
              </th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ verticalAlign: "baseline" }}>
                <FormSelector
                  name="EnvironmentHotId"
                  id="EnvironmentHotId"
                  itemLabel={"Тип греющей среды"}
                  optionsObj={{
                    Вода: "Вода",
                    "Эт. Глик.": "25FB8684-4742-4778-8D80-0C857EC465D4",
                    "Проп. Глик.": "95BF98FA-F1D5-4300-AB77-545738F9DDBF",
                  }}
                  changeUserData={changeUserData}
                  isAdditionally
                  defaultValue={"Вода"}
                />
              </td>
              <td style={{ verticalAlign: "baseline" }}>
                <FormSelector
                  name="EnvironmentColdId"
                  id="EnvironmentColdId"
                  itemLabel={"Тип нагреваемой среды"}
                  optionsObj={{
                    Вода: "Вода",
                    "Эт. Глик.": "25FB8684-4742-4778-8D80-0C857EC465D4",
                    "Проп. Глик.": "95BF98FA-F1D5-4300-AB77-545738F9DDBF",
                  }}
                  changeUserData={changeUserData}
                  isAdditionally
                  defaultValue={"Вода"}
                />
              </td>
              <td></td>
              <td rowSpan={9}>
                <div>
                  <img
                    src={vdkShema}
                    alt={vdkShema}
                    style={{ width: "300px" }}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <FormInput
                  itemLabel={"Мощность"}
                  name="Q"
                  changeUserData={changeUserData}
                  defaultValue={200}
                />
              </td>

              <td>
                <FormSelector
                  name="QMeasureId"
                  id="QMeasureId"
                  itemLabel={"Единица измерения"}
                  optionsObj={{
                    кВт: "кВт",
                    МВт: "МВт",
                    "ккал/ч": "ккал/ч",
                    "Гкал/ч": "Гкал/ч",
                  }}
                  changeUserData={changeUserData}
                  defaultValue={"кВт"}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormInput
                  itemLabel={"Расход среды"}
                  name="G1"
                  changeUserData={changeUserData}
                />
              </td>
              <td>
                <FormInput
                  itemLabel={"Расход среды"}
                  name="G2"
                  changeUserData={changeUserData}
                />
              </td>
              <td>
                <FormSelector
                  name="GMeasureId"
                  id="GMeasureId"
                  itemLabel={"Единица измерения"}
                  optionsObj={{
                    "т/ч": "т/ч",
                    "кг/с": "кг/с",
                    "м3/ч": "м3/ч",
                    "кг/ч": "кг/ч",
                    "л/ч": "л/ч",
                  }}
                  changeUserData={changeUserData}
                  defaultValue={"т/ч"}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormInput
                  itemLabel={"Температура среды на входе в ПТО(°C)"}
                  name="T1"
                  changeUserData={changeUserData}
                  defaultValue={105}
                />
              </td>
              <td>
                <FormInput
                  itemLabel={"Температура среды на входе в ПТО(°C)"}
                  name="T3"
                  changeUserData={changeUserData}
                  defaultValue={55}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormInput
                  itemLabel={"Температура среды на выходе в ПТО(°C)"}
                  name="T2"
                  changeUserData={changeUserData}
                  defaultValue={70}
                />
              </td>
              <td>
                <FormInput
                  itemLabel={"Температура среды на выходе в ПТО(°C)"}
                  name="T4"
                  changeUserData={changeUserData}
                  defaultValue={90}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormInput
                  itemLabel={"Допускаемые потери давления в ПТО"}
                  name="R1"
                  changeUserData={changeUserData}
                  defaultValue={2}
                />
              </td>
              <td>
                <FormInput
                  itemLabel={"Допускаемые потери давления в ПТО"}
                  name="R2"
                  changeUserData={changeUserData}
                  defaultValue={2}
                />
              </td>
              <td>
                <FormSelector
                  name="RMeasureId"
                  id="RMeasureId"
                  itemLabel={"Единица измерения"}
                  optionsObj={{
                    "м.вод.ст.": "м.вод.ст.",
                    бар: "бар",
                    "кгс/см2": "кгс/см2",
                    кПа: "кПа",
                  }}
                  changeUserData={changeUserData}
                  defaultValue={"м.вод.ст."}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormInput
                  itemLabel={"Запас поверхности на загрязнение %"}
                  name="X"
                  changeUserData={changeUserData}
                  defaultValue={10}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormInput
                  itemLabel={"Расчетное давление(атм)"}
                  name="P"
                  changeUserData={changeUserData}
                  defaultValue={1}
                />
              </td>
              <td>
                <FormInput
                  itemLabel={"Расчетная температура°C"}
                  name="T"
                  changeUserData={changeUserData}
                  defaultValue={150}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormSelector
                  name="FlangeAssortmentHot"
                  id="FlangeAssortmentHot"
                  itemLabel={"Втулки в порт/патрубки"}
                  optionsObj={{ Нет: "Нет", Черные: "Черные" }}
                  changeUserData={changeUserData}
                  defaultValue={"Нет"}
                />
              </td>
              <td>
                <FormSelector
                  name="FlangeAssortmentCold"
                  id="FlangeAssortmentCold"
                  itemLabel={"Втулки в порт/патрубки"}
                  optionsObj={{ Нет: "Нет", Черные: "Черные" }}
                  changeUserData={changeUserData}
                  defaultValue={"Нет"}
                />
              </td>
            </tr>
            <tr>
              <td>
                <FormSelector
                  name="PtoType"
                  id="PtoType"
                  itemLabel={"Требуемый размер ПТО"}
                  optionsObj={{
                    "Искать среди всех типов": 0,
                    "CLH 32S": 8,
                    "CLH 32M": 9,
                    "CLH 50S": 10,
                    "CLH 50M": 11,
                    "CLH 50L": 12,
                    "CLH 65S": 13,
                    "CLH 65M": 14,
                    "CLH 100S": 15,
                    "CLH 101S": 16,
                    "CLH 100M": 17,
                    "CLH 150S": 18,
                    "CLH 150M": 19,
                    "CLH 150L": 20,
                    "CLH 200S": 21,
                    "CLH 200M": 22,
                    "CLH 200L": 23,
                    "CLH 250M": 24,
                    "CLH 300S": 25,
                  }}
                  changeUserData={changeUserData}
                  defaultValue={0}
                />
              </td>

         
            </tr>
            <tr>
              <td>
                <FormSelector
                  name="GasketMaterialId"
                  id="GasketMaterialId"
                  itemLabel={"Прокладка (для разборных ТО)"}
                  optionsObj={{
                    EPDM: "c4955a47-eb63-43d8-b2b1-acd2e4024053",
                    NITRIL: "3826ace5-1361-4755-a539-805f94fd74b5",
                  }}
                  changeUserData={changeUserData}
                  defaultValue={"c4955a47-eb63-43d8-b2b1-acd2e4024053"}
                />
              </td>
              <td>
                <FormSelector
                  name="PlateMaterialId"
                  id="PlateMaterialId"
                  itemLabel={"Материал пластин"}
                  optionsObj={{
                    AISI316: "1acf494e-5860-452d-9779-3d2d4cd31c1b",
                    AISI304: "82d59718-9612-4e2e-99e4-a6f41c047913",
                  }}
                  changeUserData={changeUserData}
                  defaultValue={"1acf494e-5860-452d-9779-3d2d4cd31c1b"}
                />
              </td>
              <td>
                <FormSelector
                  name="PlateThickIndex"
                  id="PlateThickIndex"
                  itemLabel={"Толщина пластин"}
                  optionsObj={{ "Авто" : 0, "0,4": 1, "0,5": 2 , "0,6" : 3}}
                  changeUserData={changeUserData}
                  defaultValue={0}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <UserDataFields changeUserData={changeUserData} />
        <div className="button_wrapper">
          <button
            className="interface_button button-xs"
            onClick={(e) => submitHandler(e)}
          >
            Рассчитать
          </button>
          {isLoader ? <Loader /> : null}
        </div>
      </form>
      {queryTable && resultFromApi ? (
        <Table
          solutions={resultFromApi?.solutions}
          isPendingRequest={isPendingRequest}
        />
      ) : null}
      {errorRequest 
        ? alert(
            `${resultFromApi.errors[0]?.message || resultFromApi.errors[0]} ${
              resultFromApi.errors[1]?.message || ""
            } `
          )
        : null}
    </>
  );
});

export default MemoForm;
